import styled from '../../utils/style/styled';
import {  COLORS, NEUTRAL_TEXT400 } from './Colors';
import { TextStyle } from 'react-native';
import { isWeb } from './Layout';

const isQuatro = true;
export const mainTypoRegular = isQuatro?'QuattrocentoSans_400Regular':'PublicSansRegular';
export const mainTypoBold = isQuatro?'QuattrocentoSans_700Bold':'PublicSansBold';


interface typoProps {
  color?: string;
  align?: boolean;
  selectable?: boolean; // If you use condForSelectable with a selectable prop
  flexWrap?: boolean;
  opacity?: number;
}

export const condForSelectable = (props: any) => {
  return isWeb && (props?.selectable || !('selectable' in props));
};
export const MobileH1 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 28px;
  font-weight: 700;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 40px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const DesktopH1 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 36px;
  font-weight: 700;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 40px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const H1 = isWeb?DesktopH1:MobileH1;

export const MobileH2 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 24px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 36px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const H2 = isWeb?MobileH2:MobileH2;

export const DesktopH3 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 22px;
  font-weight: 700;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 30px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const MobileH3 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 22px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 30px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const H3 = isWeb?DesktopH3:MobileH3;


export const MobileH4 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 18px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 20px;
  ${(props: any) => !!props.opacity && 'opacity: ' + props.opacity + ';'}
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const DesktopH4 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 22px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 30px;
  ${(props: any) => !!props.opacity && 'opacity: ' + props.opacity + ';'}
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const H4 = isWeb?DesktopH4:MobileH4;






export const ParagraphLBold = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 18px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 25px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const ParagraphMBold = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 16px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 20px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const ParagraphSBold = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 13px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 20px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const ParagraphXLRegular = styled.Text<typoProps>`
  font-family: ${mainTypoRegular};
  font-size: 22px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 30px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const ParagraphLRegular = styled.Text<typoProps>`
  font-family: ${mainTypoRegular};
  font-size: 18px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 25px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const ParagraphMRegular = styled.Text<typoProps>`
font-family: ${mainTypoRegular};
font-size: 16px;
color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
line-height: 20px;
${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
${(props: any) => props.align && 'text-align: center;'}
${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const ParagraphMRegularTextStyle = (props: typoProps): TextStyle => {
  return {
    fontFamily: mainTypoRegular,
    fontSize: 16,
    color: props.color ? props.color : COLORS.content.primary,
    lineHeight: 20,
    textAlign: props.align ? 'center' : 'left',
    flexWrap: props.flexWrap ? 'wrap' : 'nowrap',
    userSelect: condForSelectable(props) ? 'text' : 'none', // Note: this is not a valid React Native property
  };
};

export const ParagraphSRegular = styled.Text<typoProps>`
  font-family: ${mainTypoRegular};
  font-size: 13px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 20px;
  ${(props: any) => props.align && 'text-align: center;'};
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const DesktopSessionNumber = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 40px;
  color:  ${(props: any) => props.color? props.color: NEUTRAL_TEXT400};
  line-height: 50px;
  ${(props: any) => props.align && 'text-align: right;'}
  ${isWeb && 'user-select: text;'}
`;



export const TitleSpecial = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 36px;
  line-height: 40px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;



export const MobileTitle1 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 28px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const WebTitle1 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 34px;
  line-height: 40px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const Title1 = isWeb?WebTitle1:MobileTitle1;




export const MobileTitle2 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 22px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const WebTitle2 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 24px;
  line-height: 32px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const Title2 = isWeb?WebTitle2:MobileTitle2;





export const MobileTitle3 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 18px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const WebTitle3 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 20px;
  line-height: 32px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};

`;

export const WebTitle3StyleObject = (props?: typoProps) => {
  return({
    fontFamily: mainTypoBold,
    fontSize: '20px',
    lineHeight: '32px',
  });
};

export const Title3 = isWeb?WebTitle3:MobileTitle3;





export const Subtitle1StyleObject = (props?: typoProps) => {
  return({
    fontFamily: mainTypoBold,
    fontSize: '18px',
    lineHeight: '32px',
  });
};

export const Subtitle1 = styled.Text<typoProps>`
     font-family: ${mainTypoBold};
  font-size: 18px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 32px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Subtitle2 = styled.Text<typoProps>`
  font-family: ${mainTypoBold};
  font-size: 16px;
  color:  ${(props: any) => props.color? props.color: COLORS.content.primary};
  line-height: 32px;
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Body1Bold = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoBold};
  font-size: 16px;
  line-height: 22px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const Body1BoldStyleObject = (props?: typoProps) => {
  return({
    fontFamily: mainTypoBold,
    fontSize: '16px',
    lineHeight: '22px',
    ...props?.align && {textAlign: 'center'}
  });
};

export const Body1Reg = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoRegular};
  font-size: 16px;
  line-height: 22px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const Body2Bold = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoBold};
  font-size: 14px;
  line-height: 22px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Body2Reg = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoRegular};
  font-size: 14px;
  line-height: 20px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Caption1Bold = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoBold};
  font-size: 16px;
  line-height: 18px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Caption1Reg = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoRegular};
  font-size: 16px;
  line-height: 18px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const Caption2Bold = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoBold};
  font-size: 14px;
  line-height: 16px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Caption2Reg = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoRegular};
  font-size: 14px;
  line-height: 16px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export const Caption3Bold = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoBold};
  font-size: 10px;
  line-height: 12px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;


export const Caption3Reg = styled.Text<typoProps>`
  color:  ${(props: any) => props.color? props.color: COLORS.content.secondary};
  font-family: ${mainTypoRegular};
  font-size: 10px;
  line-height: 12px; /* 142.857% */
  ${(props: any) => props.flexWrap && 'flexWrap: wrap;'};
  ${(props: any) => props.align && 'text-align: center;'}
  ${(props: any) => condForSelectable(props) && 'user-select: text;'}
`;

export type typographyTypeWeb = 'Title1' | 'Title2' | 'Title3' | 'Subtitle1' | 'Subtitle2' | 'Body1Bold' | 'Body1Reg' | 'Body2Bold' | 'Body2Reg' | 'Caption1Bold' | 'Caption1Reg' | 'Caption2Bold' | 'Caption2Reg' | 'Caption3Bold' | 'Caption3Reg';


export const typoComponents = {
  Title1,
  Title2,
  Title3,
  WebTitle1,
  WebTitle2,
  WebTitle3,
  Subtitle1,
  Subtitle2,
  Body1Bold,
  Body1Reg,
  Body2Bold,
  Body2Reg,
  Caption1Bold,
  Caption1Reg,
  Caption2Bold,
  Caption2Reg,
  Caption3Bold,
  Caption3Reg
};

